import { useField } from "formik";
import ReactQuill from "react-quill";

import "@utilities/CustomClipboard";

import "react-quill/dist/quill.snow.css";

interface IRichTextEditor {
  isShort?: boolean;
  name: string;
  value?: null | string | undefined;
}

const RichTextEditor = ({ isShort = false, name, value }: IRichTextEditor) => {
  const [field, , helpers] = useField(name);
  const classNames = `dynamicHeightEditor customQuillEditor ${isShort ? "short" : ""}`;

  return (
    <ReactQuill
      className={classNames}
      modules={{
        clipboard: {
          matchVisual: false, // Ensure it uses the custom clipboard
        },
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
        ],
      }}
      onChange={(value: string) => {
        void helpers.setValue(value);
      }}
      theme="snow"
      value={field.value || value}
    />
  );
};

export default RichTextEditor;
